module.exports = __webpack_public_path__ + "media/1alB-t-yet.8ee5f2bb.mp3";